import React from 'react';
import { Space, Typography } from 'antd';

interface MultiLangNameProps {
    nameRu: string;
    nameKz: string;
    nameEn: string;
}

const MultiLangName: React.FC<MultiLangNameProps> = ({ nameRu, nameKz, nameEn }) => {
    return (
        <Space direction="vertical">
            <Typography.Text>{nameRu}</Typography.Text>
            <Typography.Text>{nameKz}</Typography.Text>
            <Typography.Text>{nameEn}</Typography.Text>
        </Space>
    );
};

export default MultiLangName;